import { Link } from "react-router-dom";
import { SOCIALDATA } from "../../store/socialData";
import { Slide } from "react-awesome-reveal";

export default function SocialLinks({ styleT }) {
  console.log("link: ", SOCIALDATA);
  return (
    <Slide>
      <ul className={`flex items-center justify-start gap-2 ${styleT}`}>
        {SOCIALDATA.map((obj) => (
          <li key={obj.key}>
            <Link
              target="_blank"
              to={obj.link}
              // bg-[#09011b] text-[#00d9ff]
              className="bg-primary-green text-dark-forest block rounded-full p-3 hover:scale-110"
              rel="noreferrer"
            >
              {obj.icon}
            </Link>
          </li>
        ))}
      </ul>
    </Slide>
  );
}
